import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiFetch, BASE_URL } from "../../components/helpers";

import Button from "../../components/ui/Button";

const PatientHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    fetchPatientHistory();
  }, [id]);

  const fetchPatientHistory = async () => {
    setLoading(true);
    try {
      // Promise.all to fetch profile and medical history simultaneously 
      const [profileRes, historyRes] = await Promise.all([
        apiFetch(`${process.env.REACT_APP_GET_PATIENT_PROFILE}?patient_id=${id}`),
        apiFetch(`${process.env.REACT_APP_GET_PATIENT_MEDICAL_HISTORY}?patient_id=${id}`)
      ]);
      
      setPatient({
        ...(profileRes.data || {}),
        history: historyRes.data || []
      });
    } catch (error) {
      console.error("Error fetching patient details:", error);
      // Fallback for UI visualization if APIs fail or are offline
      setPatient({
        patient_id: id,
        name: "System Offline",
        mobile: "Unavailable",
        history: []
      });
    } finally {
      setLoading(false);
    }
  };



  if (loading) {
    return <div className="p-5 text-center mt-5"><div className="spinner-border text-primary" /></div>;
  }

  if (!patient) {
    return <div className="p-5 text-center mt-5">Patient not found.</div>;
  }

  return (
    <div className="container-fluid p-3 p-lg-4">
      {/* HEADER */}
      <div className="d-flex flex-column flex-md-row align-items-md-center mb-4 gap-3">
        <button 
          className="btn btn-light rounded-circle shadow-sm"
          style={{ width: 40, height: 40, background: "#fff", border: "1px solid #eee" }}
          onClick={() => navigate("/doctor/patients")}
        >
          ←
        </button>
        <div>
          <h2 className="fw-bold mb-0" style={{ color: "#0A1628" }}>
            Patient History: {patient.name}
          </h2>
          <p className="text-muted mb-0">ID: #{patient.patient_id} | Mobile: {patient.mobile}</p>
        </div>
      </div>

      <div className="row">
        {/* LEFT COLUMN: History */}
        <div className="col-12 mb-4">
          <div className="card border-0 shadow-sm rounded-4 h-100 p-4 w-100">
            <h5 className="fw-bold mb-4" style={{ color: "#0A1628" }}>Medical History</h5>
            
            {patient.history && patient.history.length > 0 ? (
              <div className="timeline" style={{ borderLeft: "2px solid #e9ecef", marginLeft: "10px", paddingLeft: "20px" }}>
                {patient.history.map((h, i) => (
                  <div key={i} className="mb-4 position-relative">
                    <div 
                      className="position-absolute rounded-circle bg-primary" 
                      style={{ width: "12px", height: "12px", left: "-27px", top: "5px" }} 
                    />
                    <div className="text-primary fw-bold mb-1" style={{ fontSize: "0.85rem" }}>{h.date}</div>
                    <div className="mb-1">{h.note}</div>
                    <div className="text-muted" style={{ fontSize: "0.85rem" }}>Attended by: {h.doctor}</div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted text-center py-4">No history records found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientHistory;
